// extracted by mini-css-extract-plugin
export default {"product__img":"ProductList_product__img__dKSJF","product__desc":"ProductList_product__desc__h+HPd","like":"ProductList_like__cdEXW"};